module.exports = __webpack_public_path__ + "media/newstyle/images/icon-speak-orange-7957299de128daa2bc503886f521dea2.svg";